const INSTAGRAM = 'INSTAGRAM';
const TWEET = 'TWEET';

export { INSTAGRAM, TWEET };
